import { HStack, ModalCloseButton } from '@chakra-ui/react';

import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
} from '@/components/v4';

const DeleteConfirmationModal = ({
    isOpen,
    onClose,
    onConfirm,
    isDeleting,
    nodeName,
}) => {
    return (
        <Modal
            closeOnOverlayClick={false}
            isCentered
            isOpen={isOpen}
            onClose={onClose}
            size="md">
            <ModalOverlay backdropFilter="blur(10px)" />
            <ModalContent>
                <ModalHeader>Delete TRS Node</ModalHeader>
                <ModalCloseButton />

                <ModalBody>
                    <Text>
                        Are you sure you want to delete the TRS Node{' '}
                        <Text as="span" fontWeight="bold">
                            &quot;{nodeName}&quot;
                        </Text>
                        ? This action cannot be undone.
                    </Text>
                </ModalBody>

                <ModalFooter>
                    <HStack spacing={3}>
                        <Button
                            variant="outline"
                            onClick={onClose}
                            isDisabled={isDeleting}>
                            Cancel
                        </Button>
                        <Button
                            colorScheme="red"
                            onClick={onConfirm}
                            isLoading={isDeleting}
                            loadingText="Deleting...">
                            Delete
                        </Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DeleteConfirmationModal;
